import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LocationSelector } from "modules/main/components/location-selector";
import { readUserDataFromLocalStorage } from "modules/main/services/location-storage";

interface LocationRequiredDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onLocationSelected: () => void;
    title?: string;
    description?: string;
}

/**
 * Displays a focused flow for selecting a location before add-to-cart.
 */
export const LocationRequiredDialog: React.FC<LocationRequiredDialogProps> = ({
    open,
    onOpenChange,
    onLocationSelected,
    title = "Selecciona tu ubicacion",
    description = "Necesitamos tu sector para mostrarte precio, stock y despacho correctos antes de agregar al carrito.",
}) => {
    const userData = readUserDataFromLocalStorage();

    const handleLocationSelected = () => {
        onLocationSelected();
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <div className="pt-2">
                    <LocationSelector
                        userData={userData}
                        onLocationSelected={handleLocationSelected}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};
